import { SvgIconProps } from '@mui/material'
import React from 'react'
import { BatteryIcon, ElectricCarIcon, EmcIcon, HeatpumpIcon, IoInterfaceIcon, MeterIcon } from './SettingsIcons'
import { DeviceCategory } from '../installation/forms'

type DeviceIconProps = {
  device: DeviceCategory
} & SvgIconProps

/**
 * Given a device type it displays the appropriate device icon.
 */
export const DeviceIcon: React.FC<DeviceIconProps> = ({ device, ...svgProps }) => {
  switch (device) {
    case 'EMC':
      return <EmcIcon {...svgProps} />
    case 'Storage':
      return <BatteryIcon {...svgProps} />
    case 'ModbusTCP Evse':
    case 'EEBus Evse':
      return <ElectricCarIcon {...svgProps} />
    case 'Heatpump':
      return <HeatpumpIcon {...svgProps} />
    case 'Meter':
      return <MeterIcon {...svgProps} />
    case 'HTC320H I/O':
    case 'MyPV I/O':
    case 'Storage I/O':
      return <IoInterfaceIcon {...svgProps} />
  }
}
